import React, { createElement } from 'react';
import { render } from 'react-dom';
import './index.css';
import { App } from './App';
// CRITICAL: Preconnect + preload hero image BEFORE React renders
// This makes the LCP image discoverable from the initial document
const preconnect = document.createElement('link');
preconnect.rel = 'preconnect';
preconnect.href = 'https://cdn.magicpatterns.com';
document.head.appendChild(preconnect);
render(<App data-id="element-3" />, document.getElementById('root'));